module.exports = __webpack_public_path__ + "src/submodules/base/assets/img/exit-from-systray.f390aa3c.gif";